import {Component, Input} from "@angular/core";

@Component({
  selector: "pcg-ng-product-price",
  template: require('./product-price.component.html')
})
export class ProductPriceComponent {

    @Input()
    public price: string = "";

    public EMPTY_PRICE_SYMBOL: string = "-";
}
